<template>
    <!--<router></router>-->
    <div v-if="currentRouteNameIsTransCam">
        <TransCamMainMenu />
    </div>
    <div v-else>
        <router-view />
    </div>

    <!--<PopupcodeCPS ref="popupCodeCPS"
                  :visible="showPopupCPS"
                  :onClose="fermerPopup"
                  :onValidate="validerCode" />-->
    <AffichageErreurVue />
</template>
<style scoped>
</style>
<script>
    import { defineComponent } from 'vue';
    import TransCamMainMenu from "./TransCamMainMenu.vue";
    import { mapActions } from 'vuex';
    import { mapGetters } from 'vuex';
    import FSEWithInfo from '@/script/FSEWithInfo';
    import PopupcodeCPS from "./PopupcodeCPS.vue";
    import ErreurAffichable from "@/script/TransCAM/ErreurAffichable";
    import RequestManager from "@/script/request";
    import AffichageErreurVue from './AffichageErreur.vue';
    export default defineComponent({
        name: "TransCAM",
        components: {
            TransCamMainMenu,
            PopupcodeCPS,
            AffichageErreurVue,
        },
            data: function () {
                return {
                    message: 'Bienvenu dans la page choix TransCam !',
                    showPopupCPS : false
                }
            },

            computed: {
                currentRouteName() {
                    return this.$route.name;
                },
                currentRouteNameIsTransCam() {
                    return this.currentRouteName == "TransCAM";
                },
                appliLance() {
                    return this.$store.getters["ConnexionStore/getAppliLance"];
                }
            },

            methods: {
                lancerGestion() {
                    this.$router.push('/transcam/Gestion');
                },

                lancerPatient() {
                    this.$router.push('/transcam/Patient');
                },

                lancerVitale() {
                    this.$router.push('/transcam/LireCarteVitale');
                },

                lancerParametre() {
                    this.$router.push('/transCam/parametre/');
                },
                initTransCAM() {
                    //alert("On init TransCAM");

                    this.$store.dispatch("ConnexionStore/setAppliLance", { name: "TransCAM" });
                    this.$store.dispatch("ConnexionStore/setAppliLaunched", true)
                    // Charge la carte CPS DANS LE STORE (Cartes/getCarteCPS) pour afficher le nom
                    // du praticien. La nouvelle connexion CPS (challenge/signature) ne pousse plus
                    // la carte au store comme l'ancien message natif 'CarteCPSConnexion' -> on la
                    // (re)charge depuis le backend (GetCPS) a l'entree de TransCAM. Si aucune carte
                    // n'est disponible, on propose la saisie du code CPS.
                    this.$store.dispatch('Cartes/chargerCarteCPS')
                        .then(() => {
                            const cps = this.$store.getters['Cartes/getCarteCPS'];
                            console.log("initTransCAM - carte CPS dans le store :", cps);
                            const vide = !cps || (cps.FieldsCount == 0 && cps.Fields == null);
                            if (vide) {
                                this.afficherPopUpCPS();
                            }
                        })
                    // Sans carte CPS (login id/mdp), nom du praticien depuis la base.
                    this.$store.dispatch('ConnexionStore/chargerPraticien');
                },
                afficherPopUpCPS() {
                    //alert("On affiche la popUp")
                    this.showPopupCPS = true;
                },

                fermerPopup() {
                    this.showPopupCPS = false;
                },
                validerCode() {
                    //alert("On valide le code !!!!\nCODE =", this.$refs.popupCodeCPS.code);
                    let code = this.$refs.popupCodeCPS.code;
                    RequestManager.EnvoyerMessageWebView({ action: "LireCartePS", parameters: [code] });
                }
            },
        created() {
            //this.initTransCAM();
        },
        mounted() {
            // Voir initTransCAM : on charge la carte CPS dans le store pour que le nom du
            // praticien s'affiche apres la connexion (CPS comme identifiant/mot de passe).
            this.$store.dispatch('Cartes/chargerCarteCPS')
                .then(() => {
                    console.log("Carte CPS chargee dans le store :", this.$store.getters['Cartes/getCarteCPS']);
                });
            // Sans carte CPS (login identifiant/mot de passe), le nom du praticien vient de la base.
            this.$store.dispatch('ConnexionStore/chargerPraticien');
            this.$nextTick(() => {
                console.log("TransCAM -> refs:", this.$refs);
            });
        },
            props: {

            }
        });
</script>
